interface Props {
  idata: string;
  title: string;
}

const VerifiedSignature = ({ idata, title }: Props) => (
  <div
    style={{
      paddingLeft: "18px",
      fontSize: "16px",
      fontWeight: "bold",
      pageBreakInside: "avoid",
    }}>
    <p style={{ margin: 0 }}>{title}</p>
    <img
      src={idata}
      alt="signature"
      style={{ maxHeight: "40px", width: "auto" }}
    />
  </div>
);
export default VerifiedSignature;
